import { render, staticRenderFns } from "./discoverThree.vue?vue&type=template&id=5d006d18&"
import script from "./discoverThree.vue?vue&type=script&lang=js&"
export * from "./discoverThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports